import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("omy_token");
    if (!token) { setLoading(false); return; }
    const cached = localStorage.getItem("omy_user");
    if (cached) { try { setUser(JSON.parse(cached)); } catch (e) {} }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("omy_user", JSON.stringify(r.data)); })
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 401 || status === 403) {
          localStorage.removeItem("omy_token");
          localStorage.removeItem("omy_user");
          setUser(null);
        }
        // réseau indisponible (hors-ligne) → on conserve la session en cache
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("omy_token", data.token);
    localStorage.setItem("omy_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("omy_token", data.token);
    localStorage.setItem("omy_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("omy_token");
    localStorage.removeItem("omy_user");
    setUser(null);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    localStorage.setItem("omy_user", JSON.stringify(data));
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
